var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"app"}},[_c('router-view',{staticClass:"main-header",style:(_vm.headerStyle),attrs:{"name":"header"}}),_c('router-view',{staticClass:"main-container",style:(_vm.headerStyle),attrs:{"name":"main"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }